export function toSnakeCase(str: string): string {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2') // lowercase/number before uppercase (e.g., isA -> is_A, version2Update -> version2_Update)
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2') // acronym before word (e.g., HTTPRequest -> HTTP_Request)
    .toLowerCase();
}
